// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ada3a7fa","453":"bd6f6598","563":"d3b9ae8a","977":"36553137"}[chunkId] + ".chunk.js";
};